<template>
  <!-- 上方主体 服务-->
  <div class="container_top" id="topCont" @mouseover="barNum = 0">
    <!-- 轮播图 -->
    <div class="topTitCont">
      
      <img style="width: 100%;display: block;" src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/jgrlxdarm6yjo2b25m3y.png" alt="" />
      <div class="cont_topTil">服务</div>
      <div class="cont_topShad">give service to</div>
    </div>
    <!-- 头部tap -->

    <!-- 服务业务 -->
    <div class="publicCloud" ref="publom" id="publicCloud">
      <div class="publ_compe_tit">服务业务</div>
      <div class="publ_compe_fy">service business</div>
      <div class="publ_compe_txt">
        秉承“科技赋能，护佑安全”的理念，
        致力于自主可控关键核心技术研发为己任,着眼<br />
        新一代网络信息基础设施及重要信息系统安全保障为使命，
        面向智慧型生产与生活提供全方位的网络与信息安全服务。
      </div>

      <div class="publCont">
        <div class="publ_img">
          <div class="img_Cont">
            <img src="https://oss.jingshucloud.com/gw-bucket/4a38b095-8183-4236-a5c1-cc63b413f9b6.png" alt="" />
            <div class="img_Cont_Tit">售后服务</div>
          </div>
          <!-- <div class="publ_Tit">优势标题文案内容</div>
            <div class="publ_Txt">
              京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，通过软件与硬件的结合。
            </div> -->
        </div>

        <div class="publ_img">
          <div class="img_Cont">
            <img src="https://oss.jingshucloud.com/gw-bucket/20e4dee8-6dea-4cde-a43f-862303a44035.png" alt="" />
            <div class="img_Cont_Tit">驱动下载</div>
          </div>
          <!-- <div class="publ_Tit">优势标题文案内容</div>
            <div class="publ_Txt">
              京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，通过软件与硬件的结合。
            </div> -->
        </div>
        <div class="publ_img">
          <div class="img_Cont">
            <img src="https://oss.jingshucloud.com/gw-bucket/159bf74f-f5f7-4f89-a7e4-4209fbb97061.png" alt="" />
            <div class="img_Cont_Tit">京数应用商店</div>
          </div>
          <!-- <div class="publ_Tit">优势标题文案内容</div>
            <div class="publ_Txt">
              京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，通过软件与硬件的结合。
            </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
      
<script>
export default {
  props: { switchNum: String },
  components: {},
  data() {
    return {
      swiperOption: {
        loop: true,
        // centeredSlides: true,
        slidesPerView: 1,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          paginationClickable: true,
        },
      },
      tapHomeFlg: false,
      tapNum: 0,
      tapFlg: "1",
    };
  },
  computed: {},
  watch: {
    switchNum(curVal, oldVal) {
      // console.log("测试switchNum",curVal, oldVal);

      if (curVal == 3) {
        document
          .getElementById("topCont")
          .scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  activated() {
    console.log(this.switchNum);
  },
  created() {
    if (this.switchNum == 3) {
      document.getElementById("topCont").scrollIntoView({ behavior: "smooth" });
    }
  },
  methods: {
    tapClic(row) {
      this.tapFlg = row;
      if (row == 1) {
        document
          .getElementById("overviewApp")
          .scrollIntoView({ behavior: "smooth" });
      }
    },
    handleScroll() {
      if (this.$refs.custom && this.$refs.custom.offsetTop) {
        // console.log(
        //   "测试滚动条",
        //   window.scrollY,
        //   this.$refs.custom.offsetTop,
        //   this.switchNum,
        //   document.body.scrollTop
        // );

        if (window.scrollY > 650) {
          var scrollTop =
            window.scrollY ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
          var scroll = scrollTop - this.i;
          this.i = scrollTop;
          if (scroll < 0) {
            this.tapHomeFlg = false;
            // console.log("up");
          } else {
            // console.log("down");
            this.tapHomeFlg = true;
            this.tapNum = 1;
          }
        } else {
          this.tapHomeFlg = false;
        }
        this.$emit("switchflg", "0");
      }
    },
  },
};
</script>
      
<style lang="less" scoped>
.container_top {
  width: 100%;
  .topTitCont{
    position: relative;
    display: flex;
    justify-content: center;
  }
  .cont_topTil {
width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    position: absolute;
    bottom: 50%;
    //left: 13%;
    font-size: 46px;
    font-weight: 600;
    color: white;
  }
  .cont_topShad {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    opacity: 0.8;
    position: absolute;
    bottom: 46%;
    //left: 13%;
    font-size: 18px;
    color: white;
  }
}

// 头部tap
.tapCont {
  position: relative;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  .tapAll {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tapOne {
    cursor: pointer;
    font-size: 20px;
    margin: 20px;
  }
  .colr {
    // background: linear-gradient(360deg, #003365 0%, #048799 100%);
    position: relative;
    color: #048799;
  }
  .colr::before {
    content: "";
    height: 3px;
    background: #048799;
    position: absolute;
    top: 44px;
    width: 100%;
  }
  @keyframes arise {
    0% {
      top: -80px;
    }
    100% {
      top: 0px;
    }
  }
  .tapHome {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0px;
    z-index: 9999;
    width: 100%;
    background: white;
    height: 103px;
    animation: arise 0.5s ease-out;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  }
  .tapPackUp {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: -130px;
    animation: packUp 0.5s ease-out;
  }
  @keyframes packUp {
    0% {
      position: fixed;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 80px;
      top: 0px;
    }
    100% {
      position: fixed;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 80px;
      top: -80px;
    }
  }
  .tapPack {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: -130px;
  }
}

// 硬件定制服务
.publicCloud {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
 margin-top:100px;
  .publ_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
  }
  .publ_compe_tit::before {
    content: "";
    height: 1px;
    background: #151a23;
    position: absolute;
    top: 60px;
    width: 100%;
  }

  .publ_compe_fy {
    font-size: 20px;
    color: #8a8c91;
  }
  .publ_compe_txt {
    width: 80%;
    // margin-top: 50px;
    margin: 60px 0;
    text-align: center;
  }
  .publCont {
    display: flex;
    // justify-content: center;
    align-items: center;
    // margin: 80px;
    // width: 87%;

    width: 100%;
    max-width: 1230px;
    margin: 0 auto;

    flex-wrap: wrap;
  }
  .publ_img {
    margin: 0 15px;
    position: relative;

    overflow: hidden;
    margin-bottom: 30px;
    width: 580px;
    height: 410px;
    // width: 31%;
  }
  .publ_img img {
    display: block;
    width: 100%;
    cursor: pointer;
    transition: ease all 0.3s;
  }
  .publ_img:hover img{
    transform: scale(1.1);
  }
  // .publ_img div {
  //   margin-top: 20px;
  // }
  .img_Cont {
    position: relative;

    // overflow: hidden;
    // height: 325px;
  }
  .img_Cont_Tit {
    position: absolute;
    bottom: 45px;
    color: #fff;
    font-size: 20px;
    margin-left: 40px;
    cursor: pointer;
  }
  .publ_Tit {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin-top:20px;
  }
  .publ_Txt {
    text-align: justify;
  }
}
</style>
      